import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { User, LogOut, KeyRound, Settings } from "lucide-react";
import { toast } from "sonner";

export default function AccountMenu() {
  const { user, setUser, logout } = useAuth();
  const [profileOpen, setProfileOpen] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "", address: user?.address || "", zone: user?.zone || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  const saveProfile = async () => {
    try { const { data } = await api.put("/auth/profile", form); setUser(data); setProfileOpen(false); toast.success("Profilo aggiornato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const changePw = async () => {
    try { await api.post("/auth/change-password", pw); setPwOpen(false); setPw({ current_password: "", new_password: "" }); toast.success("Password aggiornata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid="account-menu-trigger" className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 transition-colors">
            <div className="h-7 w-7 rounded-full bg-[#00E676]/15 flex items-center justify-center"><User className="h-4 w-4 text-[#00E676]" /></div>
            <span className="text-sm max-w-[120px] truncate hidden sm:block">{user?.name}</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#1C1C1F] border-white/10 w-56">
          <DropdownMenuLabel className="text-zinc-400 text-xs">{user?.email}</DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem data-testid="menu-profile" onClick={() => { setForm({ name: user?.name || "", phone: user?.phone || "", address: user?.address || "", zone: user?.zone || "" }); setProfileOpen(true); }} className="cursor-pointer"><Settings className="h-4 w-4 mr-2" /> Il mio profilo</DropdownMenuItem>
          <DropdownMenuItem data-testid="menu-change-password" onClick={() => setPwOpen(true)} className="cursor-pointer"><KeyRound className="h-4 w-4 mr-2" /> Cambia password</DropdownMenuItem>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem data-testid="menu-logout" onClick={logout} className="cursor-pointer text-red-400 focus:text-red-400"><LogOut className="h-4 w-4 mr-2" /> Esci</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={profileOpen} onOpenChange={setProfileOpen}>
        <DialogContent className="bg-[#1C1C1F] border-white/10">
          <DialogHeader><DialogTitle>Il mio profilo</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nome</Label><Input data-testid="account-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-[#0A0A0C] border-white/10 mt-1" /></div>
            <div><Label>Email</Label><Input value={user?.email} disabled className="bg-[#0A0A0C] border-white/10 mt-1 opacity-60" /></div>
            <div><Label>Telefono</Label><Input data-testid="account-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="bg-[#0A0A0C] border-white/10 mt-1" /></div>
            <div><Label>Indirizzo</Label><Input data-testid="account-address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="bg-[#0A0A0C] border-white/10 mt-1" /></div>
            <Button data-testid="account-save" onClick={saveProfile} className="bg-[#00E676] text-black rounded-md w-full">Salva</Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={pwOpen} onOpenChange={setPwOpen}>
        <DialogContent className="bg-[#1C1C1F] border-white/10">
          <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Password attuale</Label><Input data-testid="pw-current" type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="bg-[#0A0A0C] border-white/10 mt-1" /></div>
            <div><Label>Nuova password</Label><Input data-testid="pw-new" type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="bg-[#0A0A0C] border-white/10 mt-1" /></div>
            <Button data-testid="pw-save" onClick={changePw} className="bg-[#00E676] text-black rounded-md w-full">Aggiorna password</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
